import { PAGES_WITHOUT_OVERLAY } from '../constants';

export const isPageWithOverlay = (pathname: string) =>
  !PAGES_WITHOUT_OVERLAY.some(path => pathname.includes(path));
